import { FolderContent } from '@/api/generatedApi';
import { CopiableGridColDef } from '@/types/copiableColumn';
import { getAssetFolderDirectory, getAssetName } from '@/utils/assets';
import { getCreatorEmailValue } from '@/utils/dataGridValueGetters';
import { dateFormat } from '@/utils/format';
import {
  RenderCreatedAt,
  RenderCreator,
  RenderDetails,
  RenderFolder,
  RenderName,
} from '../ContentsTable/cellDefinitions';

export const reportTableColumns: CopiableGridColDef<FolderContent>[] = [
  {
    field: 'name',
    headerName: 'Name',
    width: 450,
    minWidth: 450,
    filterable: false,
    sortable: false,
    flex: 1,
    renderCell: RenderName,
    getCopyValue: row => (row.contentType === 'asset' ? getAssetName(row) : row.name),
  },
  {
    field: 'details',
    headerName: 'Details',
    minWidth: 170,
    filterable: false,
    sortable: false,
    renderCell: RenderDetails,
  },
  {
    field: 'folder',
    headerName: 'Folder',
    minWidth: 150,
    filterable: false,
    sortable: false,
    renderCell: RenderFolder,
    getCopyValue: row => (row.contentType === 'asset' ? getAssetFolderDirectory(row) || undefined : undefined),
  },
  {
    field: 'createdAt',
    headerName: 'Created',
    width: 100,
    filterable: false,
    sortable: false,
    renderCell: RenderCreatedAt,
    getCopyValue: row => (row.createdAt ? dateFormat(row.createdAt) : undefined),
  },
  {
    field: 'creator',
    headerName: 'Created By',
    minWidth: 130,
    flex: 2,
    filterable: false,
    sortable: false,
    renderCell: RenderCreator,
    valueGetter: getCreatorEmailValue,
    getCopyValue: row => row.creator?.email,
  },
];
